import { combineReducers } from "redux";
import { reducer as reduxFormReducer } from "redux-form";
import themeReducer from "./themeReducer";
import sidebarReducer from "./sidebarReducer";
import rtlReducer from "./rtlReducer";
import companyReducer from "../reducers/companyReducer";
import jobReducer from "../reducers/jobsReducer";
import jobFormReducer from "../reducers/jobFormReducer";
import authReducer from "../reducers/authReducer";

export { themeReducer, sidebarReducer, rtlReducer };

const reducer = combineReducers({
  form: reduxFormReducer, // mounted under "form",
  theme: themeReducer,
  sidebar: sidebarReducer,
  rtl: rtlReducer,
  companyReducer,
  jobReducer,
  jobFormReducer,
  authReducer
});

export default reducer;
